const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

exports.Metrics = {
  identityVerification: function identityVerification (payload, token, callback) {
    const requestParams = {
      host: publicConfig.external_address,
      path: `/v1/verification/listing`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  }
};